/*
 * @Descripttion:
 * @Author: 李子和
 * @Date: 2020-04-16 14:04:54
 */
export default [
  {
    path: '/statistical',
    name: '数据可视化',
    hidden: false,
    meta: {
      title: '数据可视化',
      icon: '',
      nav: 'act',
      level: 1
    },
    component: resolve => require(['@/views/Application.vue'], resolve),
    children: [
      {
        path: '/statistical',
        name: 'statistical',
        hidden: false,
        meta: {
          title: '基本数据',
          level: 1,
          nav: 'act',
          icon: ''
        },
        component: resolve => require(['@/views/statistical'], resolve)
      },
      {
        path: '/printStatistical',
        name: 'printStatistical',
        hidden: false,
        meta: {
          title: '助印数据',
          level: 1,
          nav: 'act',
          icon: ''
        },
        component: resolve => require(['@/views/statistical-print'], resolve)
      }
    ]
  },
  {
    path: '/show/:id',
    name: '寺庙情况',
    hidden: true,
    meta: {
      title: '寺庙情况',
      icon: '',
      nav: 'act',
      level: 2
    },
    component: resolve => require(['@/views/Application.vue'], resolve),
    children: [
      {
        path: '/show/:id',
        name: 'show',
        hidden: true,
        meta: {
          title: '寺庙情况',
          level: 2,
          nav: 'act',
          icon: ''
        },
        component: resolve => require(['@/views/statistical/detail'], resolve)
      }
    ]
  },
  {
    path: '/show',
    name: '总体情况',
    hidden: true,
    meta: {
      title: '寺庙情况',
      icon: '',
      nav: 'act',
      level: 2
    },
    component: resolve => require(['@/views/Application.vue'], resolve),
    children: [
      {
        path: '/show',
        name: 'show',
        hidden: true,
        meta: {
          title: '总体情况',
          level: 2,
          nav: 'act',
          icon: ''
        },
        component: resolve => require(['@/views/statistical/detail'], resolve)
      }
    ]
  },
  {
    path: '/showPrintDatabase',
    name: 'showPrintDatabase',
    hidden: true,
    meta: {
      title: '助印数据',
      icon: '',
      nav: 'act',
      level: 2
    },
    component: resolve => require(['@/views/Application.vue'], resolve),
    redirect: '/showPrintDatabase/index',
    children: [
      {
        path: 'index',
        name: 'index',
        hidden: true,
        meta: {
          title: '助印数据',
          level: 2,
          nav: 'act',
          icon: ''
        },
        component: resolve => require(['@/views/statistical-print/detail'], resolve)
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/router/modules/router-statistical.js